/* eslint-disable react/jsx-pascal-case */
// import { Col, Form, Input, Row, ColorPicker } from "antd";
import { Row, Col, Form, Input, ColorPicker, Select } from '../ui/ot'
import dayjs from 'dayjs';
import React, { useEffect, useState } from "react";

const AdvancedSearchForm = (
    {
        propsForm = null,
        field,
        onFormFinish = () => { },
        items = []
    }
) => {
    const [form_] = Form.useForm();
    const form = propsForm ? propsForm : form_
    const [count, setCount] = useState(0);


    const setDataInitialization = () => {
        //拿個下拉選單等等的資訊
    }
    const onFinish = (values) => {
        onFormFinish({
            ...values,
        })

    }
    const onValuesChange = () => {
        let formValues = null
        formValues = form.getFieldsValue()
    }
    const setFieldValue = (name, value) => {
        form.setValue(name, value);
    };
    const getAnyFormValue = (name, count) => {
        let formValues = null;
        formValues = form.getFieldValue(name);
        return formValues;
    };
    useEffect(() => {
        setDataInitialization()
    }, [])


    return (
        <Row>
            <Col span={24}>
                <Form
                    form={form}
                    onValuesChange={onValuesChange}
                    onFinish={onFinish}
                >
                    <Row gutter={[8, 8]}>
                        <Col span={24}>
                            <FormItemComponent
                                field={field}
                                getAnyFormValue={getAnyFormValue}
                                count={count}
                                setFieldValue={setFieldValue}
                                setCount={setCount}
                                items={items}
                            />
                        </Col>
                    </Row>
                </Form>
            </Col>
        </Row>


    )
}
const FormItemComponent = ({
    field,
    initialValues = {},
    getAnyFormValue,
    count,
    setFieldValue,
    setCount,
    items = []
}) => {
    const getComponent = (type, props = {}) => {
        switch (type) {
            case "text":
                return <Input {...props} />;
            case "date_range":
                return <Input type="date" {...props} />;
            case "number_range":
                return (
                    <Input type="number"   {...props} />
                );
            case "select":
                return (
                    <Select {...props} />
                );
            default:
                return <Input {...props} />;
        }
    };
    return (
        <>
            <Row gutter={[8, 8]}>
                {items.map((item) => {
                    if (item?.type === "date_range") {
                        return (
                            <Col span={24}>
                                <Row gutter={[8, 8]}>
                                    <Col xxl={12} xl={12} lg={12} md={12} sm={12} xs={24} >
                                        <Form.Item
                                            labelCol={24}
                                            wrapperCol={24}
                                            label={item?.label+"(起)"}
                                            name={[field?.name ?? '', `${item?.name}_start`]}
                                            fieldKey={[field?.fieldKey ?? '', `${item?.name}_start`]}
                                        >
                                            {React.cloneElement(getComponent(item?.type, item?.props), { ...field })}
                                        </Form.Item>
                                    </Col>
                                    <Col xxl={12} xl={12} lg={12} md={12} sm={12} xs={24} >
                                        <Form.Item
                                            labelCol={24}
                                            wrapperCol={24}
                                            label={item?.label +"(迄)"}
                                            name={[field?.name ?? '', `${item?.name}_end`]}
                                            fieldKey={[field?.fieldKey ?? '', `${item?.name}_end`]}
                                        >
                                            {React.cloneElement(getComponent(item?.type, item?.props), { ...field })}
                                        </Form.Item>
                                    </Col>
                                </Row>
                            </Col>
                        )
                    }
                    else if (item?.type === "number_range") {
                        return (
                            <Col span={24}>
                                <Row gutter={[8, 8]}>
                                    <Col xxl={12} xl={12} lg={12} md={12} sm={12} xs={24} >
                                        <Form.Item
                                            label={item?.label}
                                            labelCol={24}
                                            wrapperCol={24}
                                            name={[field?.name ?? '', `${item?.name}_min`]}
                                            fieldKey={[field?.fieldKey ?? '', `${item?.name}_min`]}
                                        >
                                            {React.cloneElement(getComponent(item?.type, item?.props), { ...field })}
                                        </Form.Item>
                                    </Col>
                                    <Col xxl={12} xl={12} lg={12} md={12} sm={12} xs={24} >
                                        <Form.Item
                                            label={item?.label}
                                            labelCol={24}
                                            wrapperCol={24}
                                            name={[field?.name ?? '', `${item?.name}_max`]}
                                            fieldKey={[field?.fieldKey ?? '', `${item?.name}_max`]}
                                        >
                                            {React.cloneElement(getComponent(item?.type, item?.props), { ...field })}
                                        </Form.Item>
                                    </Col>
                                </Row>
                            </Col>
                        )
                    }
                    else {
                        return (
                            <Col xxl={12} xl={12} lg={12} md={12} sm={12} xs={24} >
                                <Form.Item
                                    label={item?.label}
                                    labelCol={24}
                                    wrapperCol={24}
                                    name={[field?.name ?? '', item?.name]}
                                    fieldKey={[field?.fieldKey ?? '', item?.name]}
                                >
                                    {React.cloneElement(getComponent(item?.type, item?.props), { ...field })}
                                </Form.Item>
                            </Col>

                        )
                    }

                })}
            </Row >
        </>
    );
};

export default AdvancedSearchForm;
